module.exports = __webpack_public_path__ + "static/media/sudaneze-people.9cb9e24d.svg";